var helpers = {
	windowHeight: jQuery(window).height(),
	init: function () {
		var self = this;

		jQuery(window).on(
			'resize',
			theme.helpers.throttle(function () {
				theme.helpers.windowHeight = jQuery(window).height();
				jQuery(window).trigger('scroll');
			}, 250)
		);
	},

	sessionStorage( key, value = '', minutes = 60 ) {
		var self = this;

		// get localStorage
		if( value == '' ) {
			var item = localStorage.getItem( key );

			// need to load new Value
			if( null == item ) {
				return false;
			}

			var itemJSON = JSON.parse( localStorage.getItem( key ) );
			var currentTime = new Date().getTime();

			// need to load new Value
			if( currentTime > itemJSON.timestamp ) {
				localStorage.removeItem( key );
				return false;
			}

			return itemJSON.value; // return current value
		} else {
			self.sessionStorageSet( key, value, minutes );
		}
	},

	sessionStorageSet: function( key, value, minutes = 60 ) {
		var self 		= this;
		var currentTime = new Date().getTime();
		var future 		= currentTime + ( minutes * 3600 * 16.667 );

		var object 		= { value: value, timestamp: future }
		localStorage.setItem( key, JSON.stringify(object) );
	},

	throttle: function (fn, wait) {
		var time = Date.now();
		return function () {
			if (time + wait - Date.now() < 0) {
				fn();
				time = Date.now();
			}
		};
	},

	setCookie(name, value, days) {
		var expires = '';
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=/';
	},

	getCookie(name) {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	},

	eraseCookie(name) {
		document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	},

	isOnScreen: function( element ){
		var win = jQuery(window);
	
		var viewport = {
			top : win.scrollTop(),
			left : win.scrollLeft()
		};
		viewport.right = viewport.left + win.width();
		viewport.bottom = viewport.top + win.height();
	
		var bounds = element.offset();
		bounds.right = bounds.left + element.outerWidth();
		bounds.bottom = bounds.top + element.outerHeight();
	
		return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	}
};

export { helpers };
